module.exports = __webpack_public_path__ + "img/ic_add file_2.5051afa4.svg";